import React from "react"

const SideRemoveButton = ({ onClick }) => (
    <div className="side-button" onClick={onClick}>
        <span className="icon icon-remove" />
    </div>
)

export default SideRemoveButton
